import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useCrudForm } from "../common/crudForm/useCrudForm";
import { CrudFormLayout, Field } from "../common/crudForm/crudFormLayout";
import { useAuth } from "../../AuthContext";
import { getCondicionIva, saveCondicionIva } from "../../services/condicionesIvaService";

import Joi from "joi";

// export default function CondicionesIvaForm({ initialData = { nombre: "", documento: "" }, onCancel }) {
export default function CondicionesIvaForm(props) {
  const history = useHistory();
  const { activeUser, permisos: allowedTo } = useAuth();

  const onCancel = props.onCancel;
  const title = "Condición de IVA";
  const subTitle = "Detalles";
  const initialData = { descripcion: "", generaIva: false, seLeDiscriminaIva: false };
  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Condiciones de IVA",
      link: "/condicionesiva",
    },
    {
      title: "Detalles",
    },
  ];

  const schema = Joi.object({
    _id: Joi.string(),
    descripcion: Joi.string().label("Descripción").required().messages({
      "string.empty": "Debe ingresar una descripción",
    }),
    generaIva: Joi.boolean(),
    seLeDiscriminaIva: Joi.boolean(),
  });

  const hookFetchData = async (id) => {
    try {
      const record = await getCondicionIva(id);
      return record;
    } catch {
      history.replace("/noconnection");
    }
    // const data = this.mapToViewModel(record);
  };

  const onSave = async (data) => {
    // try {
    const savedRecord = await saveCondicionIva(data);
    return savedRecord;
    // } catch (error) {
    //   throw error; // Rethrow the error to be handled by the caller
    // }
  };

  const crudForm = useCrudForm({
    defaultPath: "/condicionesIva",
    initialData,
    onSave,
    // onSuccess,
    // Local (client-side) validation still goes through the extension point.
    schema: schema,
    onLoading: props.onLoading,
    onDoneLoading: props.onDoneLoading,
    hookFetchData,

    // (d) => {
    //   const errs = {};
    //   if (!d.make?.trim()) errs.make = "Make is required.";
    //   if (!d.model?.trim()) errs.model = "Model is required.";
    //   return errs;
    // },
    // Normalize data right before it's sent.
    // transformBeforeSave: (d) => ({
    //   ...d,
    //   vin: d.vin?.toUpperCase(),
    //   registeredAt: new Date().toISOString(),
    // }),
    liveValidate: true,
  });

  // --- Overridden submit handler ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    // // 1. Custom pre-processing the base hook doesn't know about.
    // if (crudForm.data.year && Number(crudForm.data.year) > new Date().getFullYear() + 1) {
    //   crudForm.setErrors({ year: "Year can't be in the future." });
    //   return;
    // }

    // 2. Delegate to the base implementation (the "super" call).
    const ok = await crudForm.submit();

    // 3. Custom post-processing, only if the save succeeded.
    if (ok) {
      // console.log("[analytics] car_saved", crudForm.data.make, crudForm.data.model);
      // alert("Car saved!");
    }
  };

  return (
    <CrudFormLayout
      crudForm={crudForm}
      title={title}
      subTitle={subTitle}
      breadcrumbs={breadcrumbs}
      onSubmit={handleSubmit} // note: our override, not crud.handleSubmit
      onCancel={onCancel}
      // onGoBack={crudForm.goBack}
      // loading={crudForm.loading}
      // errors={crudForm.errors}
      submitLabel="Guardar"
    >
      <div className="row ">
        <Field crudForm={crudForm} label="Descripción" name="descripcion" float="true" columns="6" autoFocus={true} />
      </div>
      <div className="row ">
        <Field crudForm={crudForm} label="Genera IVA" name="generaIva" type="toggle" columns="2" />
        <Field crudForm={crudForm} label="Se Le Discrimina IVA" name="seLeDiscriminaIva" type="toggle" columns="2" />
      </div>
    </CrudFormLayout>
  );
}
